import React from 'react';
import { Container } from './styles';

const SubMenu = ({ children }) => <Container>{children}</Container>;

export default SubMenu;
